import React, { Component } from "react";
import Select from "react-select";
import {
  MDBContainer,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import { Row, Col, Label, Button } from "reactstrap";
import { NotificationManager } from "react-notifications";
import {
  subscribeConsentSecondary,
  shipmentVerifySecondary,
  shipmentVerifyInfoSecondary,
} from "../store/secondaryTrip/actions";
import { connect } from "react-redux";
import { stat } from "fs";
let userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));

class VerifyShipmentModalSecondary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isSubmitting: false,
      buttonContent: "",
      addShipment: [],
      newAddShipment: [],
      tripID: "",
      shipment: [],
      warningModal: false,
      skipShipmentModal: false,
      source: "",
      sourceId: "",
      skipAtVia: false,
      skipAtViaReason: "",
      shipmentData: [],
      missedShipmentStatus: "",
      options: [],
      selectedGroup: "",
      dropdownIButton: false,
      shipmentNumberData: [],
      shipmentIds: [],
    };
    this.wrapperRef = React.createRef();
  }
  handleSubmit = async () => {
    this.setState({ loading: true });
    this.setState({ skipShipmentModal: false });
    console.log(this.state.newAddShipment);
    let verify = {
      tripID: this.props.shipdetails?._id,
      sourceID: this.state.missedShipmentStatus
        ? this.state.selectedGroup?.value
        : this.state.sourceId,
      vehicleRegNo: this.props.shipdetails?.vehicle.regNo,
      sf_numbers: this.state.newAddShipment,
      missedShipment: this.props?.missedShipment ? true : "",
    };
    if (
      this.props.drivers.consentStatus ||
      this.props.statusSubcribeConsent === "ALLOWED"
    ) {
      if (this.state.skipAtVia) {
        verify.skipAtVia = true;
        verify.skipAtViaReason = this.state.skipAtViaReason;
        verify.shipment = [""];
      }
      this.props.submit({ verify });
      this.setState({ loading: false });
    } else {
      this.warningToggle();
      this.setState({ loading: false });
    }
  };
  submitOnNoConsent = async () => {
    let verify = {
      tripID: this.props.shipdetails?._id,
      sourceID: this.state.missedShipmentStatus
        ? this.state.selectedGroup?.value
        : this.state.sourceId,
      vehicleRegNo: this.props.shipdetails?.vehicle.regNo,
      sf_numbers: this.state.newAddShipment,
      missedShipment: this.props?.missedShipment ? true : "",
    };
    if (this.state.skipAtVia) {
      verify.skipAtVia = true;
      verify.skipAtViaReason = this.state.skipAtViaReason;
      verify.shipment = [""];
    }
    this.warningToggle();
    this.props.submit({ verify });
    this.setState({ skipAtVia: false });
  };

  subscribeConsent = (ele) => {
    this.props.subscribeConsentSecondary(ele.phone, (res) => {
      if (res.success)
        NotificationManager.success(
          "Message sent for tracking consent.",
          "Success"
        );
    });
  };

  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleClickOutside);
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this.handleClickOutside);
  };

  componentDidUpdate = () => {
    if (this.props.shipdetails?._id !== this.state?.tripID) {
      this.setState({ tripID: this.props.shipdetails?._id });

      if (
        this.props.shipdetails?.subStatus === "loading_in_progress" ||
        this.props.shipdetails?.subStatus === "arrived_at_via"
      ) {
        this.setState(
          {
            source: this.props.shipdetails?.source?.label,
            sourceId: this.props.shipdetails?.source?.hopCode,
          },
          () => {}
        );
      }

      if (
        this.props.shipdetails?.subStatus === "epod_in_progress" ||
        "in_transit"
      ) {
        this.setState(
          { missedShipmentStatus: this.props?.missedShipment },
          () => {
            if (
              this.props?.shipdetails &&
              this.state.missedShipmentStatus === true
            ) {
              let optionVia = [];
              let viaPoint = this.props.shipdetails?.via
                ? this.props.shipdetails?.via
                : [];
              let source = this.props.shipdetails?.source
                ? this.props.shipdetails?.source?.label
                : "";
              let sourceId = this.props.shipdetails?.source
                ? this.props.shipdetails?.source?.hopCode
                : "";
              let sourceLoc = {
                label: `${source}`,
                value: sourceId,
              };
              viaPoint &&
                viaPoint.map((via) => {
                  let viaLoc = {
                    label: `${via?.label}`,
                    value: via?.hopCode,
                  };
                  optionVia.push(viaLoc);
                });
              optionVia.push(sourceLoc);
              this.setState({ options: optionVia });
            }
          }
        );
      }
    }
  };

  shipmentsInput = () => {
    let add = this.state.addShipment;
    add.push("input");
    this.setState({ addShipment: add });
  };
  shipmentsInputrem = (i) => {
    console.log("remove");
    const newData = this.state.shipmentNumberData;
    newData.splice(i, 1);
    this.setState({
      shipmentNumberData: newData,
    });
    // let add = this.state.addShipment;

    // if (add.length > 1) {
    //   delete add[i];
    // }
    // this.setState({ addShipment: add });
  };
  shipmentchange = (e, i) => {
    e.preventDefault();
    let ship = this.state.shipment;
    ship[i] = e.target.value;
    this.setState({ shipment: ship });
  };
  warningToggle = () => {
    this.setState({ warningModal: !this.state.warningModal });
  };
  skipShipmentToggle = (skipAtVia) => {
    this.setState({
      skipShipmentModal: !this.state.skipShipmentModal,
      skipAtVia: skipAtVia,
    });
  };
  handleResetEdit = () => {
    this.setState({
      skipAtViaReason: "",
    });
  };
  shipmentchangeTest = (e) => {
    this.setState(
      {
        shipmentData: e.target.value,
      },
      () => {}
    );
  };
  shipmentsInput1 = () => {
    if (this.state.shipmentData?.length > 0) {
      this.setState(
        {
          addShipment: [...this.state.addShipment, this.state.shipmentData],
          newAddShipment: [
            ...this.state.newAddShipment,
            this.state.shipmentData,
          ],
        },
        () => {
          console.log(this.state.addShipment);
          console.log(this.state.newAddShipment);
          let verify = {
            tripID: this.props.shipdetails?._id,
            sourceID: this.state.missedShipmentStatus
              ? this.state.selectedGroup?.value
              : this.state.sourceId,
            vehicleRegNo: this.props.shipdetails?.vehicle.regNo,
            sf_number: this.state.shipmentData,
            missedShipment: this.props?.missedShipment ? true : "",
          };

          this.props.shipmentVerifySecondary(verify, (res) => {
            const newNumbers = this.state.shipmentNumberData;
            const shipmentArray = this.state.newAddShipment;

            this.props.shipmentVerifyInfoSecondary(
              {
                sf_number: verify.sf_number,
              },
              (response) => {
                if (res.success === true) {
                  console.log("inside if");
                  console.log(res);
                  console.log(response);
                  const newObj = {
                    SFnumber: verify.sf_number,
                    status: "Verified",
                    isOpen: false,
                    items: res?.data?.data[0]?.items,
                    deliveryIdsArray: response.data.rows[0].DELIVERY_IDS,
                  };

                  newNumbers.push(newObj);
                } else {
                  console.log("inside else");
                  const newObj = {
                    SFnumber: verify.sf_number,
                    status: "Unverified",
                    isOpen: false,
                    deliveryIdsArray: response.data.rows[0].DELIVERY_IDS,
                  };

                  console.log(verify.sf_number);

                  console.log(newObj);

                  newNumbers.push(newObj);

                  const sfIndex = shipmentArray.indexOf(verify.sf_number);
                  if (sfIndex != -1) {
                    shipmentArray.splice(sfIndex, 1);
                  }
                }

                this.setState(
                  {
                    shipmentNumberData: newNumbers,
                    newAddShipment: shipmentArray,
                  },
                  () => {
                    console.log(this.state.shipmentNumberData);
                  }
                );
              }
            );
          });

          this.props.verifyMsgReset();

          this.setState({
            shipmentData: "",
          });
        }
      );
    }
  };
  handleResetEditVerify = () => {
    this.setState(
      {
        addShipment: [],
        selectedGroup: "",
        skipAtViaReason: "",
        shipmentNumberData: [],
      },
      () => {
        this.props.verifyMsgReset();
      }
    );
  };
  //Select
  handleSelectGroup = (selectedGroup) => {
    this.setState({ selectedGroup }, () => {});
  };

  // toggleIButton = (i) => {
  //   const iData = this.state.shipmentNumberData;
  //   if (!iData[i].isOpen) {
  //     iData.map((ele) => {
  //       ele.isOpen = false;
  //       return ele;
  //     });
  //     iData[i].isOpen = !this.state.shipmentNumberData[i].isOpen;
  //   } else {
  //     iData[i].isOpen = false;
  //   }

  //   if (
  //     this.state.shipmentNumberData[i].isOpen &&
  //     this.state.shipmentNumberData[i]?.deliveryIdsArray?.length === 0
  //   ) {
  //     this.props.shipmentVerifyInfoSecondary(
  //       { sf_number: this.state.shipmentNumberData[i].SFnumber },
  //       (res) => {
  //         iData[i].deliveryIdsArray = res.data.rows[0].DELIVERY_IDS;
  //         this.setState({ ...this.state, shipmentNumberData: iData });
  //       }
  //     );
  //   } else {
  //     this.setState({ ...this.state, shipmentNumberData: iData });
  //   }
  // };

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
      const iData = this.state.shipmentNumberData;
      iData.map((ele) => {
        ele.isOpen = false;
        return ele;
      });

      this.setState({ ...this.state, shipmentNumberData: iData });
    }
  };

  render() {
    userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));
    var darkMode = this.props?.mode;
    let missedShipmentStats = this.props?.missedShipment ? true : false;
    const customStyles1 = {
      indicatorsContainer: (style) => {
        return {
          ...style,
          backgroundColor: darkMode ? "#2E2E46" : "#8e9af8",
          width: "45px",
          height: "35px",
          textAlign: "center",
          justifyContent: "center",
          borderRadius: "0px 4px 4px 0px",
        };
      },
      input: (base) => ({
        ...base,
        color: darkMode ? "#9d9d9d" : "#505d69",
      }),
      indicatorSeparator: (style) => {
        return {
          ...style,
          backgroundColor: darkMode ? "#B9B9B9" : "#8e9af8",
          margin: "4px",
        };
      },
      control: (style) => {
        return {
          ...style,
          height: "26px",
        };
      },
      dropdownIndicator: (style) => {
        return {
          ...style,
          alignSelf: "start",
        };
      },
      menu: (style) => {
        return {
          ...style,
          backgroundColor: darkMode ? "#171722" : "#ffffff",
          color: darkMode ? "#B7A9FF" : "rgb(51, 51, 51)",
          opacity: darkMode ? "1" : "",
          border: darkMode
            ? "0.5px solid #616161"
            : "0.5px solid rgb(204, 204, 204)",
          boxShadow: darkMode
            ? "0px 3px 12px rgba(0, 0, 0, 0.12)"
            : "0px 3px 12px rgba(0, 0, 0, 0.12)",
          // zIndex: "22px",
        };
      },
    };
    return (
      <React.Fragment>
        <MDBContainer className="text-capitalize">
          <MDBModal
            isOpen={this.props.isOpen}
            toggle={() => {
              this.props.toggle();
              this.handleResetEditVerify();
            }}
            centered
            size="md"
            className={
              this.state.skipShipmentModal
                ? "VerifyShipmentModal modelDark verifyFade"
                : "VerifyShipmentModal modelDark"
            }
          >
            <MDBModalHeader
              toggle={this.toggle}
              style={{
                position: "relative",
                left: "5px",
              }}
            >
              <i
                style={{
                  marginTop: "10px",
                }}
                className="fas fa-times closeDark p-3"
                onClick={() => {
                  this.props.toggle();
                  this.handleResetEditVerify();
                }}
              ></i>
              <Row>
                <Col xs="12">
                  <span
                    className="fontRoboto light__span"
                    style={{
                      color: "#0C0C0C",
                    }}
                  >
                    {userLang?.trip?.VERIFY_SHIPMENT}
                  </span>
                </Col>
                <Col xs="12">
                  <span
                    className="fontRoboto1541 dark__span"
                    style={{
                      color: "#05284E",
                    }}
                  >
                    {userLang?.trip?.TRIP_ID} :{" "}
                    {this.props?.shipdetails?.tripId}
                  </span>
                </Col>
              </Row>
            </MDBModalHeader>
            <MDBModalBody className="modalPaddingBottom">
              <Row className="pl-3">
                <Col
                  xs="12"
                  md="6"
                  className="py-2"
                  style={{
                    paddingLeft: "3px",
                  }}
                >
                  {/* <FormGroup className="select2-container"> */}
                  <Label
                    className="control-label  required fontRoboto1541 light__span"
                    style={{
                      color: "#05284E",
                    }}
                  >
                    {userLang?.common?.SOURCE} <i style={{ color: "red" }}>*</i>
                  </Label>
                  <Row>
                    {!this.state.missedShipmentStatus ||
                    !missedShipmentStats ? (
                      <Col xs={11} className="pr-0">
                        <input
                          style={{ height: "38px" }}
                          className="form-control form-control-sm w-90 light__span fontRoboto1541"
                          type="text"
                          name="source"
                          required
                          disabled
                          // value={
                          //   this.props.shipdetails
                          //     ? this.props.shipdetails?.source?.label
                          //     : ""
                          // }
                          value={this.state.source}
                          // onChange={(e) => {
                          //   // this.props.onChange({
                          //   //   target: {
                          //   //     name: "source",
                          //   //     value: e,
                          //   //   },
                          //   // });
                          // }}
                          onChange={this.searchValueSetter}
                          placeholder="Source"
                          aria-label="Source"
                          icon="fas fa-times-circle"
                        />
                      </Col>
                    ) : (
                      <Col xs={11} className="pr-0">
                        <Select
                          value={this.state.selectedGroup}
                          className="form-control-xs"
                          onChange={this.handleSelectGroup}
                          options={this.state.options}
                          classNamePrefix="select2-selection"
                          styles={customStyles1}
                        />
                      </Col>
                    )}

                    {/* <Col xs={2} className="pl-0">
                      <Button
                        style={{ height: "38px" }}
                        className="btn btn-info sharp-corners-left"
                      >
                        <MDBIcon icon="search" />
                      </Button>
                    </Col> */}
                  </Row>

                  {/* </FormGroup> */}
                </Col>
                <Col xs="12" md="6" className="py-2">
                  <Label
                    className="control-label fontRoboto15 light__span"
                    style={{
                      color: "#05284E",
                    }}
                  >
                    {userLang?.tracking?.VEHICLE_NO}
                    <i style={{ color: "red" }}>*</i>
                  </Label>
                  <Row>
                    <Col xs={11} className="pr-0">
                      <input
                        style={{ height: "38px" }}
                        required
                        className="form-control form-control-sm w-90 fontRoboto1541 light__span"
                        type="text"
                        name="vehicleNumber"
                        disabled
                        value={this.props.shipdetails?.vehicle?.regNo}
                        onChange={(e) => {
                          // this.props.onChange({
                          //   target: {
                          //     name: "vehicleNumber",
                          //     value: e,
                          //   },
                          // });
                        }}
                        placeholder="Type here..."
                      />
                    </Col>
                  </Row>
                </Col>
                <Col xs={12}>
                  <Col lg="12" className="py-2">
                    <div className="PfShipmentDiv addNewBg">
                      <Label
                        className="control-label fontRoboto15 light__span"
                        style={{
                          color: "#05284E",
                        }}
                      >
                        SF Number
                        <i style={{ color: "red" }}>*</i>
                      </Label>
                      <Row>
                        <Col xs={9} className="pr-0">
                          <input
                            value={this.state.shipmentData}
                            style={{ height: "38px", minWidth: "100%" }}
                            required
                            className="form-control form-control-sm w-100 "
                            type="text"
                            name="shipmentNumber"
                            onChange={(e) => this.shipmentchangeTest(e)}
                            placeholder="Type here..."
                          />
                          <span style={{ color: "red" }}>
                            {/* {msg ? msg : ""} */}
                          </span>
                        </Col>
                        <Col xs={3} className="pt-0">
                          <Button
                            className="AddNUmberBtn addDarkBtn pl-3 pr-3 ml-4"
                            onClick={() => this.shipmentsInput1()}
                          >
                            Add Number
                          </Button>
                        </Col>
                        {this.state.shipmentNumberData?.length >= 1
                          ? this.state.shipmentNumberData.map((a, i) => {
                              let msg = this.props.verifymsg
                                ? this.props.verifymsg
                                : "";
                              return (
                                <Col key={`${a}-${i}`} lg="12" className="py-2">
                                  <Row>
                                    <Col xs={8} className="pr-0">
                                      <input
                                        // style={{ height: "38px", minWidth:"100%"}}
                                        value={a.SFnumber}
                                        required
                                        className="form-control form-control-sm w-100 InputForm"
                                        type="text"
                                        name="shipmentNumber"
                                        onChange={(e) =>
                                          this.shipmentchange(e, i)
                                        }
                                      />
                                      <span style={{ color: "red" }}>
                                        {msg ? msg : ""}
                                      </span>
                                      {/* </Col> */}
                                      {/* <Col xs={2}> */}
                                      <div
                                        className="verifedText"
                                        style={{
                                          color:
                                            a.status === "Verified"
                                              ? "green"
                                              : "red",
                                        }}
                                      >
                                        {a.status}
                                      </div>

                                      {/* <Col xs={1} style={{ paddingTop: "15px" }}> */}
                                      <div
                                        ref={this.wrapperRef}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          position: "absolute",
                                          top: "1px",
                                          left: "160px",
                                        }}
                                      >
                                        {/* <i
                                          style={{
                                            color: "#e3e374",
                                            cursor: "pointer",
                                          }}
                                          className="fas fa-info-circle mr-1"
                                          onClick={() => this.toggleIButton(i)}
                                        ></i> */}
                                        <div className="i-tooltip-SFnumber">
                                          Delivery_IDs:
                                          {a?.deliveryIdsArray}
                                        </div>
                                        <div
                                          onClick={() =>
                                            this.shipmentsInputrem(i, a)
                                          }
                                        >
                                          <svg
                                            key={i}
                                            className="SvgIcon"
                                            // onClick={() =>
                                            //   this.shipmentsInputrem(i, a)
                                            // }
                                            width="7"
                                            height="7"
                                            viewBox="0 0 7 7"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={
                                              {
                                                // paddingTop: "2px",
                                              }
                                            }
                                          >
                                            <path
                                              d="M6 1L1 6"
                                              stroke={
                                                darkMode ? "#B7A9FF" : "#2800FC"
                                              }
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                            <path
                                              d="M1 1L6 6"
                                              stroke={
                                                darkMode ? "#B7A9FF" : "#2800FC"
                                              }
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </Col>
                                    {/* </Col> */}
                                    {/* <Col xs={1} style={{ paddingTop: "2px", top:"4px" }}>
                                      <svg
                                        key={i}
                                        className="SvgIcon"
                                        onClick={() =>
                                          this.shipmentsInputrem(i, a)
                                        }
                                        width="7"
                                        height="7"
                                        viewBox="0 0 7 7"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M6 1L1 6"
                                          stroke={
                                            darkMode ? "#B7A9FF" : "#2800FC"
                                          }
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M1 1L6 6"
                                          stroke={
                                            darkMode ? "#B7A9FF" : "#2800FC"
                                          }
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </Col> */}
                                  </Row>
                                </Col>
                              );
                            })
                          : ""}
                      </Row>
                    </div>
                  </Col>
                </Col>

                <div className="mt-2">
                  <Row>
                    <Col xs={12}>
                      {!this.props.drivers.consentStatus ? (
                        <div>
                          <div className="DriverConsentDiv driverConsentDarkdiv d-flex flex-row">
                            <div className="pr-3 ">
                              <span>
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z"
                                    stroke="#E53D2C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M7.5 10.1V7.5"
                                    stroke="#E53D2C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M7.5 4.90039H7.505"
                                    stroke="#E53D2C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </span>
                            </div>
                            <div>
                              <span className="fontRoboto12 dark__span">
                                {userLang?.trip?.DRIVER_CONSENT}
                              </span>
                            </div>
                          </div>

                          <div className="DriverConsentDiv driverConsentDarkdiv d-flex flex-row mt-2">
                            <div className="pr-3 ">
                              <span>
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z"
                                    stroke="#E53D2C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M7.5 10.1V7.5"
                                    stroke="#E53D2C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M7.5 4.90039H7.505"
                                    stroke="#E53D2C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </span>
                            </div>
                            <div>
                              <span className="fontRoboto12 dark__span">
                                {userLang?.trip?.CONSENT_LOCATION}.
                              </span>
                            </div>
                          </div>

                          <div className="mt-2">
                            <span className=" dark__span">
                              <span className="font-weight-bold dark__span">
                                {" "}
                                {userLang?.trip?.OPERATOR} :{" "}
                              </span>
                              {this.props?.operator
                                ? this.props.operator
                                : "----"}
                            </span>
                          </div>
                        </div>
                      ) : (
                        // <span>
                        //   <i
                        //     style={{ color: "#e3e374" }}
                        //     className="fas fa-info-circle mr-1"
                        //   ></i>
                        //   <span>
                        //     <span style={{ color: "red" }}>
                        //       {userLang?.trip?.DRIVER_CONSENT}
                        //     </span>
                        //     <div className="mt-1">
                        // <i
                        //   style={{ color: "#e3e374" }}
                        //   className="fas fa-info-circle mr-1"
                        // ></i>
                        //       <span style={{ color: "#1f264c" }}>
                        //         {userLang?.trip?.CONSENT_LOCATION}.
                        //       </span>
                        //     </div>

                        //     <div className="mt-2">
                        //       <span>
                        //         <span className="font-weight-bold">
                        //           {" "}
                        //           {userLang?.trip?.OPERATOR} :{" "}
                        //         </span>
                        //         {this.props.operator
                        //           ? this.props.operator
                        //           : " ----"}
                        //       </span>
                        //     </div>
                        //   </span>
                        // </span>
                        <span>
                          <div className="d-flex flex-row greenBorder driverConsentDarkdiv">
                            <div className="pr-3">
                              <span>
                                <i
                                  style={{ color: "green", fontSize: "16px" }}
                                  className="fas fa-check-circle"
                                ></i>
                              </span>
                            </div>
                            <div>
                              <span className="fontRoboto1541 light__span">
                                {userLang?.trip?.DRIVER_CONSENT_LOCATION}.
                              </span>
                            </div>
                          </div>

                          <div>
                            <span className="dark__span">
                              <span className="font-weight-bold dark__span">
                                {" "}
                                {userLang?.trip?.OPERATOR} :{" "}
                              </span>
                              {this.props.operator
                                ? this.props.operator
                                : " ----"}
                            </span>
                          </div>
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Row>
              <Row
                className="mt-4"
                style={{
                  position: "relative",
                  left: "0px",
                  paddingTop: "10px",
                }}
              >
                {/* <Col xs="3"> */}
                {this.props.shipdetails?.tracking?.current !==
                  this.props.shipdetails?.tracking?.path[0]?._id &&
                this.props.shipdetails?.tracking?.current !==
                  this.props.shipdetails?.tracking?.path[
                    this.props.shipdetails?.tracking?.path?.length - 1
                  ]._id &&
                Array.isArray(this.props.shipdetails?.tracking?.path) ? (
                  // &&
                  // this.props.shipdetails.subStatus === "arrived_at_via"
                  <Col xs="3" className="">
                    <Button
                      style={{
                        width: "100%",
                        height: "50px",
                        backgroundColor: "#05284E",
                        color: "#FFFFFF",
                      }}
                      color="danger rounded button-wide"
                      onClick={() => this.skipShipmentToggle(true)}
                    >
                      {userLang?.trip?.SKIP_SHIPMENT}
                    </Button>
                    <br />
                    <div className=" d-flex flex-row mt-2">
                      <div className="pr-3 ">
                        <span>
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z"
                              stroke="#6E6E6E"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.5 10.1V7.5"
                              stroke="#6E6E6E"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.5 4.90039H7.505"
                              stroke="#6E6E6E"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      <div>
                        <span className="fontRoboto12">
                          {userLang?.trip?.CLICK_NO_SHIPMENT}
                        </span>
                      </div>
                    </div>
                    {/* <span>
                    {" "}
                    <i className="fas fa-info-circle mr-1"></i>{" "}
                    <span>{userLang?.trip?.CLICK_NO_SHIPMENT}</span>{" "}
                  </span> */}
                  </Col>
                ) : (
                  ""
                )}
                {/* </Col> */}
                <Col xs="2">
                  <Button
                    className="fontRoboto1541 addDarkBtn"
                    style={{
                      width: "100%",
                      height: "50px",
                      backgroundColor: "#0AB38C",
                      color: "#FFFFFF",
                    }}
                    color="secondary"
                    onClick={() => this.handleResetEditVerify()}
                  >
                    {userLang?.common?.RESET}
                  </Button>
                </Col>
                <Col xs="2">
                  <Button
                    className="fontRoboto1541 addDarkBtn"
                    style={{
                      width: "100%",
                      height: "50px",
                      backgroundColor: "#05284E",
                      color: "#FFFFFF",
                    }}
                    color="primary"
                    onClick={this.handleSubmit}
                    disabled={this.state?.isSubmitting || this.state?.loading}
                  >
                    {userLang?.trip?.VERIFY}
                  </Button>
                </Col>
                {!(
                  this.props.shipdetails?.tracking?.current !==
                    this.props.shipdetails?.tracking?.path[0]?._id &&
                  this.props.shipdetails?.tracking?.current !==
                    this.props.shipdetails?.tracking?.path[
                      this.props.shipdetails?.tracking?.path?.length - 1
                    ]?._id &&
                  Array.isArray(this.props.shipdetails?.tracking?.path)
                ) ? (
                  <Col xs="3"></Col>
                ) : (
                  ""
                )}

                {this.props.shipdetails?.tracking?.current !==
                  this.props.shipdetails?.tracking?.path[0]?._id &&
                this.props.shipdetails?.tracking?.current !==
                  this.props.shipdetails?.tracking?.path[
                    this.props.shipdetails?.tracking?.path?.length - 1
                  ]?._id &&
                Array.isArray(this.props.shipdetails?.tracking?.path) &&
                this.props.shipdetails.subStatus === "arrived_at_via" ? (
                  ""
                ) : (
                  <Col xs="2"></Col>
                )}

                <Col xs={3}>
                  <Button
                    style={{
                      width: "86%",
                      height: "50px",
                      backgroundColor: "#E53D2C",
                      color: "#FFFFFF",
                    }}
                    color="primary rounded button-wide"
                    onClick={() => {
                      this.subscribeConsent(this.props.driver);
                    }}
                  >
                    {userLang?.trip?.TRIGGER_CONSENT}
                  </Button>
                </Col>
              </Row>
            </MDBModalBody>
            <div className="modalFooter">
              <Row
                style={{
                  marginTop: "8px",
                  justifySelf: "flex-start",
                  color: "red",
                }}
              >
                <div>*Unverified shipment number will not be submitted</div>
              </Row>
            </div>
            {/* <Button color="secondary" onClick={() => this.props.toggle()}>
                Cancel
              </Button> */}
            {this.props.shipdetails?.tracking?.current !==
              this.props.shipdetails?.tracking?.path[0]?._id &&
            this.props.shipdetails?.tracking?.current !==
              this.props.shipdetails?.tracking?.path[
                this.props.shipdetails?.tracking?.path?.length - 1
              ]?._id &&
            Array.isArray(this.props.shipdetails?.tracking?.path) &&
            this.props.shipdetails.tracking.path.includes(
              this.props.shipdetails?.tracking?.current
            ) &&
            this.props.shipdetails.subStatus === "loading_in_progress" ? (
              <div className="noLoading">
                ({userLang?.trip?.NO_LOADING_AT_THIS_LOCATION})
              </div>
            ) : (
              ""
            )}
            {/* <Row className="py-2 alignWithLocation">
              {this.props.shipdetails?.tracking?.current !=
                this.props.shipdetails?.tracking?.path[0]._id &&
              this.props.shipdetails?.tracking?.current !=
                this.props.shipdetails?.tracking?.path[
                  this.props.shipdetails?.tracking?.path?.length - 1
                ]._id &&
              Array.isArray(this.props.shipdetails?.tracking?.path) &&
              this.props.shipdetails.subStatus == "arrived_at_via" ? (
                <Col xs="4" className="shipMentPadding">
                  <Button
                    color="danger rounded button-wide"
                    onClick={() => this.skipShipmentToggle(true)}
                  >
                    {userLang?.trip?.SKIP_SHIPMENT}
                  </Button>
                  <br />
                  <span>
                    {" "}
                    <i className="fas fa-info-circle mr-1"></i>{" "}
                    <span>{userLang?.trip?.CLICK_NO_SHIPMENT}</span>{" "}
                  </span>
                </Col>
              ) : (
                <Col xs="4"></Col>
              )}
              <Col xs="4"></Col>
              <Col xs="4" className="verifyPadding">
                <Button
                  color="primary rounded button-wide"
                  onClick={this.handleSubmit}
                  disabled={this.state.isSubmitting || this.state.loading}
                >
                  {userLang?.trip?.VERIFY}
                </Button>
              </Col>
            </Row> */}

            <MDBModalFooter></MDBModalFooter>
          </MDBModal>
          <MDBContainer>
            <MDBModal
              isOpen={this.state.warningModal}
              toggle={this.warningToggle}
              centered
            >
              <MDBModalHeader toggle={this.warningToggle}>
                <span style={{ color: "red" }}> {userLang?.trip?.WARNING}</span>
              </MDBModalHeader>
              <MDBModalBody>
                {userLang?.trip?.SKIP_SHIPMENT_WARNING}?
              </MDBModalBody>
              <MDBModalFooter>
                <Button color="warning" onClick={this.warningToggle}>
                  {userLang?.common?.CLOSE}
                </Button>
                <Button color="danger" onClick={this.submitOnNoConsent}>
                  {userLang?.trip?.CONTINUE}
                </Button>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          <MDBContainer>
            <MDBModal
              className="SkipShipmentModal"
              isOpen={this.state.skipShipmentModal}
              toggle={this.skipShipmentToggle}
              centered
            >
              <MDBModalHeader toggle={this.skipShipmentToggle}>
                <span className="fontRoboto">
                  {" "}
                  {userLang?.trip?.SKIP_SHIPMENT_CAPS}
                </span>
              </MDBModalHeader>
              <MDBModalBody>
                <label className="fontRoboto15">
                  Why Do You Want to Skip Shipment?
                </label>
                <input
                  style={{ height: "233px", minWidth: "100%" }}
                  required
                  className="form-control  mt-2"
                  type="text"
                  name="skipAtViaReason"
                  value={this.state.skipAtViaReason}
                  onChange={(e) => {
                    this.setState({ skipAtViaReason: e.target.value });
                  }}
                  placeholder={userLang?.trip?.SKIP_SHIPMENT_PlACEHOLDER}
                />
              </MDBModalBody>
              <Row
                style={{
                  position: "relative",
                  left: "17px",
                  paddingTop: "10px",
                }}
              >
                <Col xs="3">
                  <Button
                    className="fontRoboto1541"
                    style={{
                      width: "100%",
                      height: "50px",
                      backgroundColor: "#0AB38C",
                      color: "#FFFFFF",
                    }}
                    color="secondary"
                    onClick={() => this.handleResetEdit()}
                  >
                    {userLang?.common?.RESET}
                  </Button>
                </Col>
                <Col xs="4">
                  <Button
                    className="fontRoboto1541"
                    style={{
                      width: "100%",
                      height: "50px",
                      backgroundColor: "#05284E",
                      color: "#FFFFFF",
                    }}
                    color="primary"
                    onClick={this.handleSubmit}
                    disabled={
                      this.state.skipAtViaReason?.length > 0 ? false : true
                    }
                  >
                    {userLang?.trip?.SKIP_SHIPMENT}
                  </Button>
                </Col>
                <Col xs="6"> </Col>
              </Row>

              {/* <MDBModalFooter>
             
                <Button
                  color="warning"
                  onClick={() => this.skipShipmentToggle(false)}
                >
                  {userLang?.common?.CLOSE}
                </Button>
                <Button
                  color="danger"
                  onClick={this.handleSubmit}
                  disabled={this.state.isSubmitting || this.state.loading}
                >
                  {userLang?.trip?.SKIP_SHIPMENT}
                </Button>
              </MDBModalFooter> */}
            </MDBModal>
          </MDBContainer>
        </MDBContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    indents: state.Indent.indents.assignedIndents,
    policies: state.AccessPolicy.accessPolicies.policies,
    drivers: state.Driver.drivers,
  };
};

export default connect(mapStateToProps, {
  subscribeConsentSecondary,
  shipmentVerifySecondary,
  shipmentVerifyInfoSecondary,
  //   finalizeIndent,
})(VerifyShipmentModalSecondary);
